import { useMutation, useQuery } from '@tanstack/react-query'

import { getDemoLeadDetails, setDemoLeadStatus } from './function'

const useGetDemoLeadDetails = () => {
  return useQuery(['demoLeadDetail'], getDemoLeadDetails)
}

const useSetDemoLeadStatus = () => {
  return useMutation(setDemoLeadStatus, {
    onError(e) {
      console.log(e)
    },
  })
}

export { useGetDemoLeadDetails, useSetDemoLeadStatus }
